import React from 'react';
import './Card.scss';
import { ICard } from 'src/app/interfaces';

import iconStars from 'src/assets/svg/github-stars.svg';
import iconForks from 'src/assets/svg/github-forks.svg';
import arrowRight from 'src/assets/svg/arrow-back.svg';
import SVG from 'react-svg';

const Card = ({ name, stars, forks, url, language, description }: ICard) => {
    return (
        <div className='AMB-Card'>
            <a href={`${url}/tree/master`} target='_blank' rel='noopener noreferrer' >
                <h4 className='title'>{name}</h4>
                <p className='description'>{description}</p>
                <div className='badges'>
                    <div className='badge'>
                        <span className={`language ${language}`}></span>
                        {language}
                    </div>
                    <div className='badge'>
                        <img src={iconStars} />
                        {stars}
                    </div>
                    <div className='badge'>
                        <img src={iconForks} />
                        {forks}
                    </div>
                    <div className='github-text'>
                        View on Github
                        <SVG wrapper='span' src={arrowRight} />
                    </div>
                </div>
            </a>
        </div>
    );
};

export default Card;
